"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_final_form_1 = require("react-final-form");
var react_rainbow_components_1 = require("react-rainbow-components");
var typeMap = {
    text: 'text',
    number: 'number',
};
var OverlayField = function (_a) {
    var name = _a.name, value = _a.value, validate = _a.validate, type = _a.type;
    var inputRef = react_1.useRef();
    var inputType = typeMap[type] || 'text';
    react_1.useEffect(function () {
        setTimeout(function () {
            if (inputRef.current && inputRef.current.focus) {
                inputRef.current.focus();
            }
        }, 0);
    }, []);
    return (react_1.default.createElement(react_final_form_1.Field, { className: "rainbow-m-bottom_large", name: name, initialValue: value, type: inputType, component: react_rainbow_components_1.Input, validate: validate, autoComplete: "off", ref: inputRef }));
};
OverlayField.propTypes = {
    name: prop_types_1.default.string,
    value: prop_types_1.default.any,
    validate: prop_types_1.default.func,
    type: prop_types_1.default.string.isRequired,
};
OverlayField.defaultProps = {
    name: undefined,
    value: undefined,
    validate: undefined,
};
exports.default = OverlayField;
//# sourceMappingURL=overlayField.js.map